/** @jsx jsx */
import { css, jsx } from '@emotion/react';

import * as React from 'react';

import { FormattedMessage } from 'js/lib/coursera.react-intl';

import { Typography } from '@coursera/cds-core';

import Skills from 'bundles/unified-career-academy/components/Skills';

import _t from 'i18n!nls/career-academy';

type Props = {
  skills?: (string | null | undefined)[] | null;
  roleTitle?: string | null;
};

const styles = {
  title: css`
    padding-bottom: 12px;
  `,
};

const RoleDescriptionSkills = ({ skills, roleTitle }: Props) => {
  if (!skills?.length || !roleTitle) {
    return null;
  }

  return (
    <div>
      <Typography variant="h2semibold" component="h3" css={styles.title}>
        <FormattedMessage
          message={_t(`Top {skillCount} {skillCount, plural, =1 {skill} other {skills}} needed for {roleTitle}`)}
          skillCount={skills.length}
          roleTitle={roleTitle}
        />
      </Typography>
      <Skills skills={skills} />
    </div>
  );
};

export default RoleDescriptionSkills;
